
































































import Vue from 'vue';
import Card from '@/components/Card.vue';
import { SearchItem, search } from '@/search';
import { ref, createComponent } from '@vue/composition-api';
import { IS_MOBILE } from '../constants';

export default createComponent({
  name: 'SearchCard',
  components: { Card },
  filters: {
    format(strings: string[]) {
      return strings.join(' • ');
    },
  },
  props: {
    items: { type: Array as () => SearchItem[], required: true },
  },
  setup(props, context) {
    const cardRef = ref<Vue>(null);
    const inputRef = ref<Vue & { focus: () => void }>(null);

    const results = ref<SearchItem[]>([]);
    const searchText = ref('');

    function checkEnter(e: MouseEvent) {
      if (e.which === 13) { // ENTER
        startSearch();
      }
    }

    function checkEmpty() {
      if (searchText.value === '') {
        results.value = [];
      }
    }

    function startSearch() {
      if (!cardRef.value || !inputRef.value) {
        return;
      }

      const loadingComponent = context.root.$loading.open({
        container: cardRef.value.$el,
      });


      if (IS_MOBILE) {
        // Blur the input when the search is started. This is very useful for touch devices
        // If we don't do this, anytime the user touches the screen the keyboard will open
        const input = inputRef.value.$refs.input as HTMLInputElement;
        input.blur();
      }

      setTimeout(() => loadingComponent.close(), 0.5 * 1000);
      results.value = search(props.items, searchText.value);
    }

    function clear() {
      results.value = [];
      searchText.value = '';
      if (inputRef.value) {
        inputRef.value.focus();
      }
    }

    return {
      startSearch,
      searchText,
      results,
      checkEmpty,
      checkEnter,
      clear,
      card: cardRef,
      input: inputRef,
    };
  },
});
